import { ErrorBanner } from "@fmc-digital/ui";

interface FormErrorBannerProps {
  error: unknown;
  getErrorMessage: (e: unknown) => string;
  className?: string;
  testId?: string;
}

export function FormErrorBanner({
  error,
  getErrorMessage,
  className,
  testId,
}: Readonly<FormErrorBannerProps>) {
  if (!error) return null;

  return (
    <div className={className} data-testid={testId}>
      <ErrorBanner message={getErrorMessage(error)} />
    </div>
  );
}
